/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GisDataStoreMetadataMappingModel {
        public gisDataStoreMetadataMappings: Wars.Domain.Model.Gis.GisDatastoreMetadataMapping[];
        public gisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        public unusedGisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        public selectedGisDataStore: Wars.Domain.Model.Gis.GisDatastore;

        constructor(public processConfigurationId: string,
            private gisDataStoreMetadataMappingService: services.GisDataStoreMetadataMappingService,
            private gisDataStoreService: services.GisDatastoreService,
            private treeService: services.TreeService,
            private $q: angular.IQService) {

            $q.all([
                gisDataStoreService.getGisDatastores().then(r => {
                    this.gisDatastores = r;
                }),
                gisDataStoreMetadataMappingService.getGisDatastoreMetadataMappings(processConfigurationId).then(r => {
                    this.gisDataStoreMetadataMappings = r;
                    this.gisDataStoreMetadataMappings.forEach(g => {
                        let mappings = [];

                        for (let i = 1; i < 21; i++) {
                            mappings.push(
                            {
                                mappingProperty: g["gisDatastorePropertyMapping" + i],
                                name: g.gisDatastore["metadata" + i + "PropertyName"],
                                index: i
                            });
                        }

                        (<any>g).mappings = mappings;
                    });
                })
            ]).then(() => {
                this.unusedGisDatastores=Enumerable.from(this.gisDatastores).
                    where(g=>Enumerable.from(this.gisDataStoreMetadataMappings).all(gd=>gd.gisDataStore_id !== g.id)).toArray();
            });


        }

        public onDragOver($event) {

        }

        public getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getDisplayName(treeItem);
        }

        public onDropTreeItem($event, index, gisDataStoreMetadataMapping, mapping) {
            var treeItem = this.treeService.createTreeItemFromItemDropped(() => {
                gisDataStoreMetadataMapping["gisDatastorePropertyMapping" + index] = treeItem;
                gisDataStoreMetadataMapping["gisDatastorePropertyMapping" + index + "_id"] = treeItem.id;
                mapping.mappingProperty = treeItem;

                this.save();
            });
        }

        public removeBinding(gisDataStoreMetadataMapping, mapping) {
            mapping.mappingProperty.entityAspect.setDeleted();
            mapping.mappingProperty = null;
            gisDataStoreMetadataMapping["gisDatastorePropertyMapping" + mapping.index] = null;

            this.save();
        }

        public add() {
            let newMapping = this.gisDataStoreMetadataMappingService.createGisDatastoreMetadataMapping();
            newMapping.processConfiguration_id = this.processConfigurationId;
            newMapping.gisDatastore = this.selectedGisDataStore;

            this.gisDataStoreMetadataMappings.push(newMapping);

            this.save();
        }

        public save() {
            this.gisDataStoreMetadataMappingService.saveAllChanges();
        }

    }
}